import { render, staticRenderFns } from "./SsoSettings.vue?vue&type=template&id=3d8fef1a&scoped=true"
import script from "./SsoSettings.vue?vue&type=script&lang=js"
export * from "./SsoSettings.vue?vue&type=script&lang=js"
import style0 from "./SsoSettings.vue?vue&type=style&index=0&id=3d8fef1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8fef1a",
  null
  
)

export default component.exports